import request from "@/utils/request.js"

// 兑奖奖品二维码列表
export const listPrizeCodes = (pageData, formData) => {
    return request.get(`/prize-codes/${pageData.page}/${pageData.pageSize}`, {params:formData})
}

// 兑奖奖品二维码-批量导出二维码图片
export const exportQrcodePrizeCodes = (formData) => {
    return request.get(`/prize-codes/qrcode/export`, {params: formData, responseType: "blob"})
}

// 批量生成兑奖奖品二维码
export const generateQrcodePrizeCodes = (formData) => {
    return request.post(`/prize-codes/generate`, formData);
};

// 获取一个可用的兑奖奖品二维码
export const getQrcodePrizeCodesAvailable = () => {
    return request.get(`/prize-codes/available`)
}

// 导出单个兑奖奖品二维码图片
export const singleQrcodePrizeCodes = (formData) => {
    return request.get(`/prize-codes/qrcode`, {params: formData, responseType: "blob"})
}
